/**
 * Debounce a function to only run after a certain amount of time has passed
 * since the last time it was called. The timer resets every time the function
 * is called.
 *
 * @internal scope: workspace
 */
export function debounceTimeout(fn, wait) {
    let timeout;
    let latestThis;
    let latestArgs;
    const debounced = function (...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        latestThis = this;
        latestArgs = args;
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            timeout = undefined;
            fn.apply(latestThis, latestArgs);
        }, wait);
    };
    const cancel = () => {
        if (timeout !== undefined) {
            clearTimeout(timeout);
            timeout = undefined;
        }
    };
    const flush = () => {
        if (timeout !== undefined) {
            clearTimeout(timeout);
            timeout = undefined;
            fn.apply(latestThis, latestArgs);
        }
    };
    return Object.assign(debounced, { cancel, flush });
}
